import { useEffect, useState } from "react"
import { Navigate, useParams } from "react-router-dom"
import { superAdminCouncilApi } from "@/lib/api"
import { useToast } from "@/hooks/use-toast"
import { LoadingSpinner } from "@/components/ui/loading-spinner"

export default function CouncilDeletionGuard({ children }: { children: React.ReactNode }) {
  const { councilId } = useParams()
  const { toast } = useToast()
  const [checking, setChecking] = useState(true)
  const [blocked, setBlocked] = useState(false)

  useEffect(() => {
    if (!councilId) {
      setChecking(false)
      return
    }
    let cancelled = false
    superAdminCouncilApi
      .getSelfDestructStatus(councilId)
      .then((res) => {
        if (cancelled) return
        const status = (res.data.data as any)?.deletionStatus
        if (status === "DELETED") {
          toast({ title: "Access denied", description: "This Water Bureau has been deleted.", variant: "destructive" })
          setBlocked(true)
        }
      })
      .catch(() => {
        // Non-super-admin or network error — allow access; permission guards handle the rest.
      })
      .finally(() => {
        if (!cancelled) setChecking(false)
      })
    return () => { cancelled = true }
  }, [councilId, toast])

  if (checking) return <LoadingSpinner />
  if (blocked) return <Navigate to="/manage-waterbureau" replace />
  return <>{children}</>
}
